module.exports = __webpack_public_path__ + "./Bonnie_1843d8d4ab6d9661e968e5a1d1286d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Bonnie.jpg
// module id = 516
// module chunks = 0